export default __webpack_public_path__ + "../staticImages/celebration-green-88x88.gif";